import { useCallback, useState } from "react";
import useWeb3 from "../useWeb3";
import { getAstroNovaPreSaleV2Contract } from "../../utils/contractHelpers";
import { useWeb3React } from "@web3-react/core";
import Environment from "../../utils/Environment";

const CuurentRoundAstraNovaV2 = () => {
  const [balance, setBalance] = useState(null);
  const { account } = useWeb3React();
  const web3 = useWeb3();

  const tokenAddressAstraNovaV2 = Environment.AstroNovaPreSaleV2;
  const AstraNovaContractPresaleV2 = getAstroNovaPreSaleV2Contract(
    tokenAddressAstraNovaV2,
    web3
  );

  // const project = localStorage.getItem("project");

  const cuurentRoundAstraNovaV2 = useCallback(
    async (proj) => {
      if (proj == "ASTRANOVA") {
        try {
          const buy = await AstraNovaContractPresaleV2.methods
            .getRoundCount()
            .call();

          return buy;
        } catch (error) {
          // console.log("dlsflasdfjlasdf", error);
          throw error;
        }
      }
    },
    [, AstraNovaContractPresaleV2, account, web3]
  );
  return { cuurentRoundAstraNovaV2: cuurentRoundAstraNovaV2 };
};
export default CuurentRoundAstraNovaV2;
